import store from '.././store';
import { replacePlaceholders } from '@/utils/replacePlaceholders';
import { convertFontFamily } from '@/utils/fontFamily';
import { conditionalBlockTrue } from '@/utils/conditionalBlockTrue';
import QRCodeStyling from 'qr-code-styling';

/* function generateQrHtml(url, size) {
  console.log(url, size)
  const qrCode = new QRCodeStyling({
    width: size,
    height: size,
    data: url,
    type: 'svg',
  });

  // Generiere den SVG-Code
  return qrCode.getRawData('svg').then(svgData => {
    return `
      <div style="padding: 16px; text-align: center;">
        ${svgData}  <!-- SVG-Code wird hier eingebettet -->
      </div>
    `;
  });
} */
  function generateQrHtml(url, size = 128) {
    const qrCode = new QRCodeStyling({
      width: size,
      height: size,
      data: url,
      type: 'svg',
    });
  
    return new Promise((resolve) => {
      // QR-Code in ein virtuelles SVG-Element rendern
      const svgContainer = document.createElement('div');
      qrCode.append(svgContainer);  // Render QR-Code in den virtuellen Container
  
      // Warte, bis das QR-Code-SVG fertig ist
      setTimeout(() => {
        const svgElement = svgContainer.querySelector('svg');
        if (svgElement) {
          const svgHtml = svgElement.outerHTML;  // Extrahiere den SVG-Code als String
          resolve(`
            <div style="padding: 16px; text-align: center;">
              ${svgHtml}
              <span class="codeContainer" contenteditable="false" name="QRCodekw181561722262826" param="2" snippable="barcode" title="QRCodekw181561722262826"><span class="cs_temp" contenteditable="false" unselectable="on">QRCodekw181561722262826: </span>
              <xsl:element name="img"><xsl:attribute name="src">
              <span class="XPATHContainer" contenteditable="false" data-snippet-key="REL-URL" data-snippet-value="REST/barcode/get/png" title="'REST/barcode/get/png'">
                &lt;xsl:value-of select="'REST/barcode/get/png'"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="f" data-snippet-value="2" title="'?f=2'">
                &lt;xsl:value-of select="'?f=2'"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="n" data-snippet-value="QRCodekw181561722262826" title="'&amp;n=QRCodekw181561722262826'">
                 &lt;xsl:value-of select="'&amp;amp;n=QRCodekw181561722262826'"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="h" data-snippet-value="25" title="'&amp;h=25'">
                 &lt;xsl:value-of select="'&amp;amp;h=25'"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="w" data-snippet-value="25" title="'&amp;w=25'"> 
                 &lt;xsl:value-of select="'&amp;amp;w=25'"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="qz" data-snippet-value="false" title="'&amp;qz=false'">
                 &lt;xsl:value-of select="'&amp;amp;qz=false'"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="v" data-snippet-value="" title="'&amp;v='">
                 &lt;xsl:value-of select="'&amp;amp;v='"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="'BCD'" title="fn:encode-for-uri('BCD')"> 
                 &lt;xsl:value-of select="fn:encode-for-uri('BCD')"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="'%0A'" title="'%0A'">
                 &lt;xsl:value-of select="'%0A'"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="'002'" title="fn:encode-for-uri('002')">
                 &lt;xsl:value-of select="fn:encode-for-uri('002')"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="'%0A'" title="'%0A'">
                 &lt;xsl:value-of select="'%0A'"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="'1'" title="fn:encode-for-uri('1')">
                 &lt;xsl:value-of select="fn:encode-for-uri('1')"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="'%0A'" title="'%0A'">
                 &lt;xsl:value-of select="'%0A'"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="'SCT'" title="fn:encode-for-uri('SCT')"> 
                 &lt;xsl:value-of select="fn:encode-for-uri('SCT')"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="'%0A'" title="'%0A'"> 
                 &lt;xsl:value-of select="'%0A'"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="/document/Zahlung/Kontodaten/BIC" title="fn:encode-for-uri(/document/Zahlung/Kontodaten/BIC)">
                 &lt;xsl:value-of select="fn:encode-for-uri(/document/Zahlung/Kontodaten/BIC)"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="'%0A'" title="'%0A'">
                 &lt;xsl:value-of select="'%0A'"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="'lidl.de'" title="fn:encode-for-uri('lidl.de')"> &lt;xsl:value-of select="fn:encode-for-uri('lidl.de')"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="'%0A'" title="'%0A'"> 
                 &lt;xsl:value-of select="'%0A'"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="replace(/document/Zahlung/Kontodaten/IBAN,' ','')" title="fn:encode-for-uri(replace(/document/Zahlung/Kontodaten/IBAN,' ',''))">
                 &lt;xsl:value-of select="fn:encode-for-uri(replace(/document/Zahlung/Kontodaten/IBAN,' ',''))"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="'%0A'" title="'%0A'"> &lt;xsl:value-of select="'%0A'"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="'EUR'" title="fn:encode-for-uri('EUR')">
                 &lt;xsl:value-of select="fn:encode-for-uri('EUR')"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="/document/Zahlung/Mahnungen/Saldo_offen" title="fn:encode-for-uri(/document/Zahlung/Mahnungen/Saldo_offen)">
                 &lt;xsl:value-of select="fn:encode-for-uri(/document/Zahlung/Mahnungen/Saldo_offen)"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="'%0A'" title="'%0A'"> 
                 &lt;xsl:value-of select="'%0A'"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="'%0A'" title="'%0A'"> &lt;xsl:value-of select="'%0A'"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="'%0A'" title="'%0A'">
                 &lt;xsl:value-of select="'%0A'"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="/document/Zahlung/Kontodaten/Verwendungszweck" title="fn:encode-for-uri(/document/Zahlung/Kontodaten/Verwendungszweck)"> &lt;xsl:value-of select="fn:encode-for-uri(/document/Zahlung/Kontodaten/Verwendungszweck)"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="' CA '" title="fn:encode-for-uri(' CA ')"> &lt;xsl:value-of select="fn:encode-for-uri(' CA ')"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="'00'" title="fn:encode-for-uri('00')">
                 &lt;xsl:value-of select="fn:encode-for-uri('00')"/&gt;</span><span class="XPATHContainer" contenteditable="false" data-snippet-key="value-part" data-snippet-value="/document/Kopfdaten/Kundennummer" title="fn:encode-for-uri(/document/Kopfdaten/Kundennummer)"> &lt;xsl:value-of select="fn:encode-for-uri(/document/Kopfdaten/Kundennummer)"/&gt;</span>
                 </xsl:attribute>
                 <xsl:attribute name="alt" select="'QRCodekw181561722262826'"/>
                 <xsl:attribute name="style" select="'width:25mm;height:25mm;content-width:25mm;content-height:25mm'"/>
                 </xsl:element></span>
            </div>
          `);
        } else {
          resolve('QR Code konnte nicht generiert werden.');
        }
      }, 100);  // Warte kurz, um sicherzustellen, dass das SVG gerendert wurde
    });
  }

function collectMediaQueries(emailData) {
  let mediaQueries = '';

  function traverseBlocks(blockId) {
    const block = emailData[blockId];
    if (block.type === 'Html' && block.mediaQueries) {
      mediaQueries += block.mediaQueries;
    }
    if (block.data?.props?.childrenIds) {
      block.data.props.childrenIds.forEach(childId => traverseBlocks(childId));
    }
  }

  // Beginne beim root-Block
  emailData.root.data.childrenIds.forEach(blockId => traverseBlocks(blockId));

  return mediaQueries;
}

function conditionBlocks(block, emailData, preview) { 
  const xPathPlaceholders = store.getters.getXPathPlaceholders;
    return block.data.props.rules.map(rule => {
      if (rule.operator == 'else') return '';
      const xsl = `${xPathPlaceholders.find(p => p.placeholder === rule.statement)?.xpath ||'' }${rule?.operator || ''}${rule?.value || ''}`;
      return `<xsl:when test="${xsl}">
<div class="placeHolderDescription">${rule?.conditionName || 'description'}</div>
<div class="placeHolder" contenteditable="false">
${rule.conditionalBlock? convertBlockToHtml(rule.conditionalBlock, emailData, preview) : '<div> No conditional block found </div>'}
</div>
</xsl:when>`;
  }).join('');
};

function getBlockStyle(block, defaultFontSize) {
  const style = block.data?.style || {};
  const padding = style.padding || { top: 0, bottom: 0, left: 0, right: 0 };
  const fontFamily = convertFontFamily(style?.fontFamily) 

  return {
    padding: `${padding.top}px ${padding.right}px ${padding.bottom}px ${padding.left}px`,
    backgroundColor: style.backgroundColor || 'transparent',
    border: style.borderColor ? `${style.borderColor} ${style?.borderWidth || 1}px solid` : 'none',
    borderRadius: style.borderRadius ? `${style?.borderRadius}px` : '0',
    color: style.color || null,
    fontWeight: style.fontWeight || 'normal',
    textAlign: style.textAlign || 'left',
    fontSize: style.fontSize ? `${style.fontSize}px` : `${defaultFontSize}px`,
    fontFamily: fontFamily
  };
}

function convertBlockToHtml(blockId, emailData, preview, maxExpression) {
  const block = emailData[blockId];
  const type = block.type;
  const defaultFontSize = emailData.root.data.fontSize
  const style = getBlockStyle(block, defaultFontSize);
  const msoPaddingUpper=`<!--[if mso]>
<table width="100%" cellspacing="0" cellpadding="0" border="0">
  <tr>
    <td colspan="3" height="${block.data.style ? block.data.style.padding.top : 0}px" style="background-color: ${style.backgroundColor || 'transparent'}">
      <img src="https://via.placeholder.com/1x1" width="1" height="${block.data.style ? block.data.style.padding.top : 0}" style="display:block;" alt="" />
    </td>
  </tr>
  <tr>
    <td width="${block.data.style ? block.data.style.padding.left : 0}px" style="background-color: ${style.backgroundColor || 'transparent'}">
      <img src="https://via.placeholder.com/1x1" width="${block.data.style ? block.data.style.padding.left : 0}" height="1" style="display:block;" alt="" />
    </td>
    <td align=${block.data.style && block.data.style.textAlign ? block.data.style.textAlign : 'left'} style="display: block;">
<![endif]-->`

 const msoPaddingLower = `<!--[if mso]>
    </td>
    <td width="${block.data.style ? block.data.style.padding.right : 0}px" style="background-color: ${style.backgroundColor || 'transparent'}">
      <img src="https://via.placeholder.com/1x1" width="${block.data.style ? block.data.style.padding.right : 0}" height="1" style="display:block;" alt="" />
    </td>
  </tr>
  <tr>
    <td colspan="3" height="${block.data.style ? block.data.style.padding.bottom : 0}px" style="background-color: ${style.backgroundColor || 'transparent'}">
      <img src="https://via.placeholder.com/1x1" width="1" height="${block.data.style ? block.data.style.padding.bottom : 0}" style="display:block;" alt="" />
    </td>
  </tr>
</table>
<![endif]-->`

  let blockClass = '';
  if (block.data.props.classNames && block.data.props.classNames.length > 0) { // check if classNames exist and are not empty
    blockClass = `class="${block.data.props.classNames.join(' ')}"`;
  }

  function generateBlock(){
  switch (type) {
    case 'Heading':
      const headingStyle = {
        padding: `${block.data.style.padding.top}px ${block.data.style.padding.right}px ${block.data.style.padding.bottom}px ${block.data.style.padding.left}px`,
        backgroundColor: block.data.style.backgroundColor || 'transparent',
        textAlign: block.data.style.textAlign || 'left',
        fontFamily: convertFontFamily(block.data.style?.fontFamily),
        color: block.data.style.color || null
      }
      return `<${block.data.props?.level || 'h2'} ${blockClass}  style='${styleToString(headingStyle)}'>${replacePlaceholders(block.data.props.text, preview)}</${block.data.props?.level || 'h2'}>`;
    case 'Text':
      return `<div ${blockClass} style='${styleToString(style)}'>${replacePlaceholders(block.data.props.text, preview, block.data.props.rules)}</div>`;
    case 'Button':
      const buttonStyle = {
        color: block.data.props.buttonTextColor || '#FFFFFF',
        backgroundColor: block.data.props.buttonBackgroundColor || '#999999',
        borderRadius: block.data.props.buttonStyle === 'pill' ? '64px' : '4px',
        display: block.data.props.fullWidth ? 'block' : 'inline-block',
        padding: (() => {
          switch (block.data.props.size) {
            case 'x-small': return '4px 8px';
            case 'small': return '8px 12px';
            case 'large': return '16px 32px';
            default: return '12px 20px';
          }
        })(),
        textDecoration: 'none',
      };
      return `<div style="${styleToString(style)}" ${blockClass}>
<a href="${block.data.props.url}" style="${styleToString(buttonStyle)}" target="_blank">
<span style="mso-text-raise:15px">
&nbsp;
</span>
<span>${block.data.props.text}</span>
<span style="mso-text-raise:-15px">
&nbsp;
</span>
</a>
</div>`;
    case 'Divider':
      return `<div style="padding: ${style.padding}" ${blockClass}>
<hr style="width:100%;border:none;border-top:${block.data.props.lineHeight || 1}px transparent ${block.data.props.lineColor || '#CCCCCC'};margin:0;">
</div>`;
case 'Spacer':
  return `<div style="height: ${block.data?.props?.height || 16}px; background-color: transparent">
</div>`;
    case 'Image':
      const width= block.data.props.width? `${block.data.props.width}px` : 'auto'; 
      /* const width= block.data.props?.width || 'auto'; */
      const height= block.data.props.height? `${block.data.props.height}px` : 'auto'; 
      /* const height= block.data.props?.height || 'auto'; */
      const border = block.data.style.borderColor? `${block.data.style.borderColor} 1px solid` : 'none';
      const imgStyle = {
        width: width,
        height: height,
        maxWidth: '100%',
        outline: 'none',
        border: border,
        textDecoration: 'none',
        verticalAlign: 'middle',
        display: 'inline-block'}
      let imgDivStyle
      if(block.data?.style?.position) {
            const position = block.data.style.position 
            const left = `${block.data.style.direction.left}px`;
            const top = `${block.data.style.direction.top}px`;
            const textAlign = style?.textAlign || 'left'
            const backgroundColor = style?.backgroundColor || 'transparent'
           imgDivStyle = {
              textAlign: textAlign,
              position: position,
              backgroundColor: backgroundColor,
              left: left,
              top: top,
              padding: `${block.data.style.padding.top}px ${block.data.style.padding.right}px ${block.data.style.padding.bottom}px ${block.data.style.padding.left}px`
            }
        } else {
          const textAlign = style?.textAlign || 'left'
          imgDivStyle = { 
            textAlign: textAlign,
            padding: `${block.data.style.padding.top}px ${block.data.style.padding.right}px ${block.data.style.padding.bottom}px ${block.data.style.padding.left}px` }
        }
      if(block.data.props?.link){
      return `<div style="${styleToString(imgDivStyle)};" ${blockClass}>
<a href="${block.data.props.link}">
<img src="${block.data.props.url}" alt="${block.data.props.alt}" style="${styleToString(imgStyle)}" /> 
</a>
</div>`;}
      else{
      return`<!--[if mso]>
<table role="presentation" width="${block.data.props.width  || 200}" height="${block.data.props.height ||200}" cellpadding="0" cellspacing="0" border="0">
  <tr>
    <td>
    <img src="${block.data.props.url}" alt="${block.data.props.alt}" 
    width="${block.data.props.width  || 200}" 
    height="${block.data.props.height||200}"
    />
    </td>
  </tr>
</table>
<![endif]-->
<!--[if mso]><div style="width:0px; height:0px; overflow:hidden; display:none; visibility:hidden; mso-hide:all;"><![endif]-->
<div style="${styleToString(imgDivStyle)};" ${blockClass}>
  <img src="${block.data.props.url}" alt="${block.data.props.alt}" style="${styleToString(imgStyle)}" />
</div>
<!--[if mso]></div><![endif]-->`
              }
    case 'ColumnsContainer':
      const columns = block.data.props.columns.slice(0, block.data.props.columnsCount);
      const gap = block.data.props.columnsGap / 2 || 0;
      const props = block.data.props
  
      const columnStyles = columns.map((column, index) => ({
      boxSizing: 'content-box',
      width: props?.fixedWidths ? `${props.fixedWidths[index]}px` : 'auto',
      verticalAlign: props?.verticalAlign ? props?.verticalAlign[index] : 'middle',
      paddingLeft: index === 0 ? '0' : `${gap}px`,
      paddingRight: index === columns.length - 1 ? '0' : `${gap}px`
      }));

      return `<div style="${styleToString(style)}" ${blockClass}>
<table align="center" width="100%" cellpadding="0" border="0" style="table-layout: fixed; border-collapse: collapse;">
<tbody>
<tr style="width: 100%">
${columns.map((column, index) => `
<td style="${styleToString(columnStyles[index])}">
${column.childrenIds.map(childId => convertBlockToHtml(childId, emailData, preview)).join('')}
</td>`).join('')}
</tr>
</tbody>
</table>
</div>`;
    case 'Container':
      return `<div ${blockClass} style="${styleToString(style)}; width: ${block.data.style?.width ? `${block.data.style.width}px`: "inherit"}; height: ${block.data.style?.height ? `${block.data.style.height}px`: "auto"}">
${block.data.props.childrenIds.map(childId => convertBlockToHtml(childId, emailData, preview)).join('')}
</div>`;
  /*   case 'Container':
      return `<div ${blockClass}>
${block.data.props.childrenIds.map(childId => convertBlockToHtml(childId, emailData)).join('')}
</div>`; */
  case 'Qr':
    generateQrHtml(block.data.props.url, block.data.props.size)
    case 'Html':
      return `<div ${blockClass} style="${styleToString(style)}">
${block.data.props.contents}
</div>`;
   case 'Ruleset' :
    const elseId = block.data.props.rules.find(rule => rule.operator == 'else')?.conditionalBlock || null; 
    const elseBlock = elseId ? convertBlockToHtml(elseId, emailData, preview) : '<div> No else block found </div>';
    const ruleName = `RULE_${blockId}`
    const title =`${block.data.props.name}_:_${ruleName}` 
      //return `<span class="codeContainer" contenteditable="false" name="RULE_372_3959959559" title="Anrede_:_15271604960869999">
      if(preview && !maxExpression){
        if(block.data.props.childrenIds.length === 0) return '<div> No conditional block found </div>'
        return `${block.data.props.childrenIds.map(childId => conditionalBlockTrue(childId, block.data) ? convertBlockToHtml(childId, emailData, preview, maxExpression) : '').join('')}`
        //return convertBlockToHtml(block.data.props.childrenIds[0], emailData, preview)
      }else if (preview && maxExpression){
        if(block.data.props.childrenIds.length === 0) return '<div> No conditional block found </div>'
       /*  let maxExpressionString = ''
        for (let i = 0; i < block.data.props.childrenIds.length; i++){
          convertBlockToHtml(block.data.props.childrenIds[i], emailData, preview).concat(maxExpressionString)
        }
        console.log('test')
        return maxExpressionString */
        return `${block.data.props.childrenIds.map(childId => convertBlockToHtml(childId, emailData, preview, maxExpression)).join('')}`
      }else {
      return `<span class="codeContainer" contenteditable="false" name="${ruleName}" title="${title}">
<xsl:choose>
${conditionBlocks(block, emailData)}
<xsl:otherwise>
<div class="placeHolderDescription">Otherwise</div>
${elseBlock}
</xsl:otherwise></xsl:choose></span>` }
    default:
      return '';
  } }
  return `${msoPaddingUpper} ${generateBlock()} ${msoPaddingLower}`;
  //return generateBlock();
  
}

export function convertJsonToHtml(emailData, preview, maxExpression) {
  const rootBlockIds = emailData.root.data.childrenIds;
  const htmlBlocks = rootBlockIds.map(blockId => convertBlockToHtml(blockId, emailData, preview, maxExpression));
  // Media Queries sammeln
  const collectedMediaQueries = collectMediaQueries(emailData);
  const globalMediaQueries = store.getters.getMediaQueries;
  return`<!doctype html>
<html>
<head>
<style>
${collectedMediaQueries} ${globalMediaQueries}
</style>
<meta charset="UTF-8"></meta>
</head>
<body>
<div class="backdrop" style='background-color:${emailData.root.data.backdropColor};color:${emailData.root.data.textColor};font-family:${convertFontFamily(emailData.root.data.fontFamily)};font-size:${emailData.root.data.fontSize}px;font-weight:400;letter-spacing:0.15008px;line-height:1.5;margin:0;padding:32px 0;min-height:100%;width:100%'>
<table class="canvas" align="center" width="100%" style="margin:0 auto; position: relative ;max-width:600px;background-color:${emailData.root.data.canvasColor}" role="presentation" cellspacing="0" cellpadding="0" border="0">
<tbody>
<tr style="width:100%">
<td>
${htmlBlocks.join('<!-- -->')}
</td>
</tr>
</tbody>
</table>
</div>
</body>
</html>
`;
}

function styleToString(style) {
  return Object.entries(style)
    .map(([key, value]) => `${camelToKebabCase(key)}: ${value};`)
    .join(' ');
}

function camelToKebabCase(str) {
  return str.replace(/[A-Z]/g, letter => `-${letter.toLowerCase()}`);
}  
